import {Component, Input, OnInit} from '@angular/core';
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";
import {filter, first, switchMap, takeUntil} from "rxjs/operators";
import {Utils} from "../../../../../shared/utils/utils";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {ProductService} from "../../../product.service";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../store';
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";
import {Website} from "../../../website";
import {WebsiteService} from "../../../../website.service";
import {TypeUtils} from "../../../../../shared/utils/type-utils";
import {Subject} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {UserSubscription} from "../../../../../user/user-subscription";
import {Product} from "../../../product";

@Component({
    selector: 'db-booster-trouble-instructions',
    templateUrl: './booster-trouble-instructions.component.html',
    styleUrls: ['./booster-trouble-instructions.component.scss'],
    standalone: false
})
export class BoosterTroubleInstructionsComponent implements OnInit {

  @Input() isPaid: boolean;
  @Input() insideWebsite?: boolean;
  @Input() website?: Website;
  @Input() currentSubscription?: UserSubscription;
  @Input() isIO?: boolean;

  public ioIsActive: boolean;
  public loading: boolean;
  public pageLoading: boolean = true;
  public disconnected: boolean;
  public restNoRoute: boolean;
  public imageOptimizerPlugin: Product;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _activeModal: DbActiveModal,
    private _productService: ProductService,
    private _store: Store<fromStore.DbStoreState>,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _websiteService: WebsiteService
  ) {
  }

  ngOnInit() {
    this._getWebsiteDomainData();
    this._getImageOptimizer();
  }


  private _getImageOptimizer(): void {
    this._store.select(fromStore.getWebsitePluginsLoaded(this.website?.id))
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() =>
          this._store.select(fromStore.getWebsiteImageOptimizerPlugin(this.website?.id)),
        ),
        takeUntil(this._destroyStream$)
      )
      .subscribe((imageOptimizerPlugin) => {
        this.imageOptimizerPlugin = imageOptimizerPlugin;
        this.ioIsActive = imageOptimizerPlugin.active
      });
  }

  private _getWebsiteDomainData(): void {
    this._store.select(fromStore.getTroubleShootData(this.website?.id))
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe((troubleshootData: any) => {
        if (!TypeUtils.isNull(troubleshootData)) {
          this.disconnected = troubleshootData === 'alive_but_not_connected';
          this.restNoRoute = troubleshootData === 'error';
          this.pageLoading = false;
        }
        ;
      });
  }

  public closeModal(): void {
    this._activeModal.close();
  }

  public downloadBoosterPlugin(): void {
    this.loading = true;
    this._productService.startDownloadingPlugin(177)
      .pipe(
        first(response => !!response),
      )
      .subscribe(response => {
        if (response && response.success) {
          Utils.downloadBlob(response.data, 'speed-optimizer');
        } else {
          NotifierComponent.notify(
            new Notification(response.message || "something went wrong", NotificationType.DANGER)
          );
        }
        this.loading = false;
      });
  }

  public downloadIOPlugin(): void {
    this.loading = true;
    this._productService.startDownloadingPlugin(69)
      .pipe(
        first(response => !!response),
      )
      .subscribe(response => {
        if (response && response.success) {
          Utils.downloadBlob(response.data, 'image-optimizer-wd');
        } else {
          NotifierComponent.notify(
            new Notification(response.message || "something went wrong", NotificationType.DANGER)
          );
        }
        this.loading = false;
      });
  }

  public troubleRequest(): void {
    if (this.isPaid) {
      if (typeof window['zE'] !== 'undefined') {

        window['Smooch']?.open();
      }
    } else {
      // wp.org url
      window.open('https://wordpress.org/support/plugin/tenweb-speed-optimizer/', '_blank', 'noopener,noreferrer,');
    }
    this._activeModal.close();
  }

  public redirect(): void {
    this._router.navigate([`../cloudflare`], {relativeTo: this._route});
  }
}
